import { ElementRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';

import { ValuePair } from '../../interfaces/ValuePair';
import { KeyCodes } from '../../keylistener/key-code.enum';
export class BaseSelectComponent implements ControlValueAccessor {
  // tslint:disable-next-line:no-input-rename
  @Input('class')
  public componentClass: string;
  @Input()
  public placeholder = 'Please select some values';
  @Input()
  public items: Array<ValuePair>;
  @Input()
  public disabled = false;

  @ViewChild('button')
  protected button: ElementRef;

  protected validateFn: Function;
  protected activeIndex = -1;
  public panelOpen = false;
  public getItems(): Array<ValuePair> {
    return this.items;
  }

  public writeValue(obj: any): void {
    if (obj) {
      return;
    }
    return;
  }

  public toggle(event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.panelOpen = !this.panelOpen;
    if (this.panelOpen) {
      this.onOpen();
    } else {
      this.onClose();
    }
    this.activeIndex = 0;
  }

  public onOpen(): void {
    this.activeIndex = 0;
  }

  public onClose(): void {
    this.activeIndex = 0;
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  // Is needed by the child components
  public validate(c: FormControl): boolean {
    return this.validateFn(c);
  }

  public handleKeyboardEvent(keyCode: number, event: KeyboardEvent): void {
    if (!this.disabled) {
      if (keyCode === KeyCodes.LEFT) {
        this.activeIndex = 0;
      } else if (keyCode === KeyCodes.RIGHT) {
        this.activeIndex = this.items.length - 1;
      } else if (keyCode === KeyCodes.UP) {
        this.activeIndex =
          (--this.activeIndex + this.items.length) % this.items.length;
      } else if (keyCode === KeyCodes.DOWN) {
        this.activeIndex = ++this.activeIndex % this.items.length;
      } else if (keyCode === KeyCodes.ENTER) {
        if (this.activeIndex >= 0 && this.activeIndex < this.items.length) {
          this.select(this.items[this.activeIndex]);
        }
      } else if (keyCode === KeyCodes.ESCAPE) {
        this.button.nativeElement.focus();
        this.panelOpen = false;
      }
    }
    event.preventDefault();
  }

  public selectActive(index: number): void {
    this.activeIndex = index;
  }

  public isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  protected select(item: ValuePair, event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (item) {
      return;
    }
  }

  protected propagateChange = (_: any): void => {
    return;
  };
}
